var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeFillWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.35,
    height: 19.35,
    viewBox: "0 0 19.35 19.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15972",
    "data-name": "Path 15972",
    d: "M0,0H19.35V19.35H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15973",
    "data-name": "Path 15973",
    d: "M1.181,10.256a8.871,8.871,0,0,1,17.446,0,8.871,8.871,0,0,1-17.446,0ZM9.9,14.288a4.031,4.031,0,1,0-4.031-4.031A4.031,4.031,0,0,0,9.9,14.288Zm0-1.613a2.419,2.419,0,1,1,2.419-2.419A2.419,2.419,0,0,1,9.9,12.675Z",
    transform: "translate(-0.229 -0.581)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFillWhite);
export default __webpack_public_path__ + "static/media/eye-fill-white.2defb260f3efa9276722d27dc5fb9add.svg";
export { ForwardRef as ReactComponent };